import { render } from "./Splash.vue?vue&type=template&id=1c4b3345&ts=true"
import script from "./Splash.vue?vue&type=script&lang=ts"
export * from "./Splash.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__